import { AudioQuality, AudioQualityInfo, SubscriptionTier, SubscriptionLimits } from '../types/models';

export const AUDIO_QUALITY_INFO: Record<AudioQuality, AudioQualityInfo> = {
  low: {
    quality: 'low',
    bitrate: '128 kbps',
    format: 'MP3',
    sampleRate: '44.1 kHz',
    requiresSubscription: null, // Free tier
  },
  medium: {
    quality: 'medium',
    bitrate: '320 kbps',
    format: 'MP3',
    sampleRate: '44.1 kHz',
    requiresSubscription: 'plus',
  },
  high: {
    quality: 'high',
    bitrate: 'Lossless',
    format: 'FLAC',
    sampleRate: '44.1 kHz',
    bitDepth: '16-bit',
    requiresSubscription: 'premium',
  },
  max: {
    quality: 'max',
    bitrate: 'Hi-Res',
    format: 'FLAC',
    sampleRate: 'Up to 192 kHz',
    bitDepth: 'Up to 24-bit',
    requiresSubscription: 'premium',
  },
};

export const SUBSCRIPTION_LIMITS: Record<SubscriptionTier, SubscriptionLimits> = {
  free: {
    maxAudioQuality: 'low',
    unlimitedSkips: false,
    offlineMode: false,
    adFree: false,
  },
  plus: {
    maxAudioQuality: 'medium',
    unlimitedSkips: true,
    offlineMode: true,
    adFree: true,
  },
  premium: {
    maxAudioQuality: 'max',
    unlimitedSkips: true,
    offlineMode: true,
    adFree: true,
  },
};

export const QUALITY_LABELS: Record<AudioQuality, string> = {
  low: 'Low (128k)',
  medium: 'Medium (320k)',
  high: 'High (16-bit 44.1kHz)',
  max: 'Max (24-bit 192kHz)',
};

export const SUBSCRIPTION_TIER_LABELS: Record<SubscriptionTier, string> = {
  free: 'Free',
  plus: 'Plus',
  premium: 'Premium',
};

export const DEFAULT_AUDIO_QUALITY: AudioQuality = 'low';

export function getMaxQualityForTier(tier: SubscriptionTier): AudioQuality {
  return SUBSCRIPTION_LIMITS[tier].maxAudioQuality;
}

export function canAccessQuality(userTier: SubscriptionTier, quality: AudioQuality): boolean {
  const requiredTier = AUDIO_QUALITY_INFO[quality].requiresSubscription;
  
  if (!requiredTier) return true; // Free quality
  
  const tierOrder: SubscriptionTier[] = ['free', 'plus', 'premium'];
  const userTierIndex = tierOrder.indexOf(userTier);
  const requiredTierIndex = tierOrder.indexOf(requiredTier);
  
  return userTierIndex >= requiredTierIndex;
}

export function getAvailableQualities(userTier: SubscriptionTier): AudioQuality[] {
  return Object.keys(AUDIO_QUALITY_INFO).filter(quality => 
    canAccessQuality(userTier, quality as AudioQuality)
  ) as AudioQuality[];
}